import * as config from '../config';

export const getFormatBySize = size => {
  return config.formats.filter(format => format.size === size)[0];
};
